<template>
  <!-- 隐私政策弹窗（Amber Logic 设计） -->
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    custom-class="privacy-dialog"
    width="820px"
    top="8vh"
  >
    <!-- 自定义头部 -->
    <template #title>
      <div class="privacy-dialog__header">
        <div class="privacy-dialog__header-info">
          <div class="privacy-dialog__badge">
            <i class="material-icons">shield</i>
          </div>
          <div>
            <h2 class="privacy-dialog__title">米晴科技隐私政策</h2>
            <p class="privacy-dialog__subtitle">
              生效日期：{{ effectiveDate }} ｜ 更新日期：{{ updateDate }}
            </p>
          </div>
        </div>
        <button class="privacy-dialog__close" @click="close" aria-label="关闭">
          <i class="material-icons">close</i>
        </button>
      </div>
    </template>

    <!-- 正文 -->
    <div class="privacy-dialog__body" ref="body">
      <!-- 顶部引言 -->
      <section class="privacy-dialog__intro">
        <p>
          <strong>上海市米晴科技有限公司</strong>（以下简称"米晴科技"或"我们"）尊重并保护所有使用本公司产品及服务的用户个人隐私权。
          为了给您提供更准确、更优质的智能寄存柜产品与服务，本公司将严格按照本隐私政策的规定使用和披露您的个人信息。
        </p>
        <p>
          请您在使用米晴科技官网（<a href="https://www.xiaojinbox.cn" target="_blank" rel="noopener">www.miqingtec.com</a>）、
          智能寄存柜硬件设备及关联小程序 / 后台管理系统（以下合称"本服务"）前，仔细阅读并充分理解本政策的全部内容，
          特别是以<strong>粗体</strong>标识的条款。
        </p>
        <div class="privacy-dialog__alert">
          <i class="material-icons">info</i>
          <span>
            勾选"我已阅读并同意"或继续使用本服务，即视为您已充分理解并同意本政策全部内容。
            如您不同意本政策任何条款，请立即停止使用本服务。
          </span>
        </div>
      </section>

      <!-- 目录 -->
      <nav class="privacy-dialog__toc">
        <h3 class="privacy-dialog__toc-title">目录</h3>
        <ol class="privacy-dialog__toc-list">
          <li v-for="(section, idx) in sections" :key="idx">
            <a :href="'#privacy-section-' + idx" @click.prevent="scrollTo(idx)">
              {{ idx + 1 }}. {{ section.title }}
            </a>
          </li>
        </ol>
      </nav>

      <!-- 政策条款 -->
      <section
        v-for="(section, idx) in sections"
        :key="section.title"
        :id="'privacy-section-' + idx"
        class="privacy-dialog__section"
      >
        <h3 class="privacy-dialog__section-title">
          <span class="privacy-dialog__section-number">{{ idx + 1 }}</span>
          {{ section.title }}
        </h3>
        <div class="privacy-dialog__section-content" v-html="section.content"></div>
      </section>

      <!-- 联系方式卡片 -->
      <section class="privacy-dialog__contact-card">
        <h3 class="privacy-dialog__contact-title">
          <i class="material-icons">contact_support</i>
          如何联系我们
        </h3>
        <div class="privacy-dialog__contact-grid">
          <div class="privacy-dialog__contact-item">
            <span class="privacy-dialog__contact-label">公司名称</span>
            <span class="privacy-dialog__contact-value">上海市米晴科技有限公司</span>
          </div>
          <div class="privacy-dialog__contact-item">
            <span class="privacy-dialog__contact-label">客服热线</span>
            <a href="tel:400-0811-363" class="privacy-dialog__contact-value privacy-dialog__contact-value--link">
              400-0811-363
            </a>
          </div>
          <div class="privacy-dialog__contact-item">
            <span class="privacy-dialog__contact-label">客服邮箱</span>
            <a href="mailto:miqingtec2020@163.com" class="privacy-dialog__contact-value privacy-dialog__contact-value--link">
              miqingtec2020@163.com
            </a>
          </div>
          <div class="privacy-dialog__contact-item">
            <span class="privacy-dialog__contact-label">办公地址</span>
            <span class="privacy-dialog__contact-value">
              上海市嘉定区翔江公路1863号洲扬众创园8幢229
            </span>
          </div>
        </div>
        <p class="privacy-dialog__contact-note">
          我们将在 <strong>15 个工作日</strong>内对您的请求进行回复。如您对本隐私政策或我们的数据处理有任何疑问、意见或建议，欢迎随时与我们联系。
        </p>
      </section>
    </div>

    <!-- 底部操作 -->
    <template #footer>
      <div class="privacy-dialog__footer">
        <span class="privacy-dialog__footer-hint">
          <i class="material-icons">verified_user</i>
          米晴科技承诺严格遵守《个人信息保护法》《网络安全法》《数据安全法》等法律法规
        </span>
        <div class="privacy-dialog__footer-actions">
          <button class="privacy-dialog__btn privacy-dialog__btn--ghost" @click="close">
            关闭
          </button>
          <button class="privacy-dialog__btn privacy-dialog__btn--primary" @click="handleAgree">
            <i class="material-icons">check_circle</i>
            我已阅读并同意
          </button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { eventBus } from '@/utils/eventBus'

export default {
  name: 'PrivacyDialog',

  data() {
    return {
      visible: false,
      effectiveDate: '2024 年 01 月 01 日',
      updateDate: '2026 年 04 月 24 日',
      sections: [
        {
          title: '引言与适用范围',
          content: `
            <p>
              本政策适用于米晴科技向您提供的所有智能寄存柜产品、官方网站、关联微信小程序、商户后台管理系统，以及未来新增的其他产品与服务（统称"本服务"）。
            </p>
            <p>
              我们深知个人信息对您的重要性，并将按照法律法规的规定并参照行业最佳实践，以诚信、透明、负责任的方式对您的个人信息进行处理。
            </p>
            <p>
              <strong>特别说明：</strong>本政策不适用于米晴科技向企业客户提供的<strong>企业级服务</strong>中，由企业客户控制的终端用户数据，此类数据的处理由客户自身的隐私政策约定。
            </p>
          `
        },
        {
          title: '我们如何收集您的个人信息',
          content: `
            <p>我们会在您使用本服务的过程中，出于以下目的收集您主动提供或产生的信息：</p>
            <h4>2.1 您主动提交的信息</h4>
            <ul>
              <li><strong>合作申请信息：</strong>姓名、联系电话、投放场地类型、需求描述等，用于处理您的合作咨询；</li>
              <li><strong>客户服务信息：</strong>您在使用客服电话、在线咨询时提供的联系方式、问题描述与通话 / 会话记录；</li>
              <li><strong>业务合同信息：</strong>签约时提供的公司名称、法人信息、营业执照、收款账户等商务资质信息。</li>
            </ul>
            <h4>2.2 使用智能寄存柜时产生的信息</h4>
            <ul>
              <li><strong>存取身份凭证：</strong>手机号、人脸识别特征（仅脱敏后的特征值）、验证码、二维码等，用于识别同一存柜用户；</li>
              <li><strong>订单交易数据：</strong>存柜时间、取件时间、使用时长、消费金额、支付渠道；</li>
              <li><strong>设备运行数据：</strong>柜门开关、温湿度、摄像头异常告警等，用于设备安全与故障溯源。</li>
            </ul>
            <h4>2.3 自动收集的技术信息</h4>
            <ul>
              <li><strong>日志信息：</strong>访问本官网时，我们会自动收集 IP 地址、浏览器类型、访问时间、来源页面等；</li>
              <li><strong>Cookie 与同类技术：</strong>用于记住您的偏好、分析网站流量（详见第 8 节）。</li>
            </ul>
            <p>
              <strong>拒绝提供的后果：</strong>如您拒绝提供合作申请必要信息，我们可能无法为您提供对应的商务咨询服务，但不影响您访问官网其他公开页面。
            </p>
          `
        },
        {
          title: '我们如何使用您的个人信息',
          content: `
            <p>我们仅在为实现以下目的所必需的范围内使用您的个人信息：</p>
            <ul>
              <li>处理您的合作申请、商务咨询与售后支持请求；</li>
              <li>向您发送产品更新、活动通知、合同续约提醒等服务通知（您可随时选择退订）；</li>
              <li>保障智能寄存柜设备安全、交易安全、防止未授权访问及欺诈行为；</li>
              <li>统计分析服务的使用情况，优化产品功能与用户体验；</li>
              <li>遵守适用法律法规、监管机构或司法机关的合法要求。</li>
            </ul>
            <p>
              <strong>若我们需要将信息用于本政策未载明的其他用途，我们会事先征得您的明示同意。</strong>
            </p>
          `
        },
        {
          title: '我们如何共享、转让、公开披露您的个人信息',
          content: `
            <h4>4.1 共享</h4>
            <p>我们不会向任何第三方共享您的个人信息，除非：</p>
            <ul>
              <li>已取得您的事先同意或您主动请求；</li>
              <li>与为您提供服务所必需的第三方服务商共享（如短信验证码供应商、支付通道、云服务器、物流服务等），我们会与其签署严格的数据处理协议；</li>
              <li>根据法律法规、监管部门或司法机关的强制性要求；</li>
              <li>在合理必要情况下保护米晴科技、您或其他用户的人身与财产安全。</li>
            </ul>
            <h4>4.2 转让</h4>
            <p>
              我们不会将您的个人信息转让给任何第三方。<strong>仅当发生合并、收购或破产清算时</strong>，可能涉及个人信息的转让；届时我们会要求新的持有方继续受本政策约束，否则将要求其重新向您征求授权同意。
            </p>
            <h4>4.3 公开披露</h4>
            <p>我们仅在以下情形下公开披露您的个人信息：</p>
            <ul>
              <li>获得您的明示同意；</li>
              <li>基于法律法规、强制性行政或司法要求所必须的情形。</li>
            </ul>
          `
        },
        {
          title: '我们如何存储您的个人信息',
          content: `
            <h4>5.1 存储地点</h4>
            <p>
              您的个人信息将存储于<strong>中华人民共和国境内</strong>，我们使用符合国家标准的数据中心与云服务（如阿里云、腾讯云等）。如涉及跨境传输，我们将按照法律法规要求单独征求您的同意并完成必要的安全评估。
            </p>
            <h4>5.2 存储期限</h4>
            <p>我们仅在实现本政策所述目的所必需的最短期限内保留您的个人信息：</p>
            <ul>
              <li><strong>合作申请信息：</strong>自提交之日起保留 3 年，期满后脱敏或删除；</li>
              <li><strong>订单与交易数据：</strong>根据电子商务法等相关规定保留至少 3 年；</li>
              <li><strong>系统日志：</strong>根据网络安全法保留不少于 6 个月。</li>
            </ul>
            <p>超出上述期限后，我们将对您的个人信息进行删除或匿名化处理。</p>
          `
        },
        {
          title: '我们如何保护您的个人信息安全',
          content: `
            <p>我们采取符合行业标准的多层次安全措施保护您的个人信息：</p>
            <ul>
              <li><strong>技术措施：</strong>采用 HTTPS/TLS 加密传输、AES-256 存储加密、动态脱敏、访问令牌、多因素认证等；</li>
              <li><strong>管理措施：</strong>建立数据安全管理制度，实行最小权限原则，数据访问日志可审计；</li>
              <li><strong>设备安全：</strong>智能寄存柜采用工业级安全主板与动态开箱算法，全程加密存取码传输；</li>
              <li><strong>员工培训：</strong>对接触个人信息的员工进行定期的安全与隐私合规培训。</li>
            </ul>
            <h4>安全事件响应</h4>
            <p>
              若不幸发生个人信息安全事件，我们将按照法律法规要求，在 <strong>72 小时内</strong>向监管机构报告，并及时告知您事件概况、我们已采取的措施和您可自行降低风险的建议。
            </p>
          `
        },
        {
          title: '您的个人信息权利',
          content: `
            <p>根据中华人民共和国相关法律法规，您对自己的个人信息享有以下权利：</p>
            <ul>
              <li><strong>查阅权：</strong>随时查询和获取我们所持有的您的个人信息副本；</li>
              <li><strong>更正 / 补充权：</strong>对不准确或不完整的信息提出更正；</li>
              <li><strong>删除权：</strong>在符合法定情形下要求删除您的个人信息；</li>
              <li><strong>撤回同意权：</strong>撤回您先前给予的任何同意；</li>
              <li><strong>注销权：</strong>申请注销合作账户（若适用）；</li>
              <li><strong>拒绝自动化决策：</strong>对仅通过自动化决策做出的、对您有重大影响的决定提出异议；</li>
              <li><strong>投诉举报：</strong>向网信、工信、公安等监管部门进行投诉举报。</li>
            </ul>
            <p>
              您可以通过第 9 节提供的联系方式行使上述权利，我们将在 <strong>15 个工作日</strong>内回复。
            </p>
          `
        },
        {
          title: 'Cookie 与同类技术',
          content: `
            <p>
              为确保本网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。
            </p>
            <h4>我们使用 Cookie 的用途：</h4>
            <ul>
              <li><strong>必要 Cookie：</strong>保持登录状态、记录表单填写进度；</li>
              <li><strong>性能 Cookie：</strong>统计访问量、分析热门页面，用以优化页面加载性能；</li>
              <li><strong>偏好 Cookie：</strong>记录语言偏好、显示偏好等设置。</li>
            </ul>
            <p>
              您可以通过浏览器设置拒绝所有或部分 Cookie，但这可能影响您使用本网站的部分功能。大部分浏览器都提供了清除 Cookie 的方式，您可以在浏览器的帮助文件中查找操作方式。
            </p>
          `
        },
        {
          title: '未成年人保护',
          content: `
            <p>
              米晴科技面向企业客户提供 B 端智能寄存解决方案，<strong>本网站不主动面向未成年人提供服务</strong>。
            </p>
            <p>
              如果我们发现自己在未事先获得可证实的父母或监护人同意的情况下收集了未成年人（尤其是不满 14 周岁儿童）的个人信息，我们会设法尽快删除相关数据。
            </p>
            <p>
              如您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第 9 节联系方式与我们联系。
            </p>
          `
        },
        {
          title: '本政策的更新',
          content: `
            <p>
              我们可能会不时更新本政策。当本政策发生<strong>重大变更</strong>（如服务模式变化、个人信息共享范围变化、使用目的变化等）时，我们将在本页面发布更新版本，并通过官网公告、站内消息或短信等方式通知您。
            </p>
            <p>
              若您在本政策更新后继续使用本服务，即视为您已同意更新后的政策内容。您可随时在本页面查看最新版本。
            </p>
          `
        }
      ]
    }
  },

  mounted() {
    eventBus.$on('open-privacy-dialog', this.open)
  },

  beforeDestroy() {
    eventBus.$off('open-privacy-dialog', this.open)
  },

  methods: {
    open() {
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.body) {
          this.$refs.body.scrollTop = 0
        }
      })
    },

    close() {
      this.visible = false
    },

    handleAgree() {
      this.$message({
        message: '感谢您的阅读与同意',
        type: 'success',
        customClass: 'amber-message'
      })
      this.close()
    },

    scrollTo(idx) {
      const el = document.getElementById('privacy-section-' + idx)
      if (el && this.$refs.body) {
        const offsetTop = el.offsetTop - 12
        this.$refs.body.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss">
// ============ Element UI Dialog 样式覆盖 ============
.el-dialog.privacy-dialog {
  border-radius: $border-radius-xl;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);

  @include mobile {
    width: 94% !important;
    margin-top: 4vh !important;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 68vh;
    overflow: hidden;
  }

  .el-dialog__footer {
    padding: 0;
    border-top: 1px solid $border-color;
  }
}

// ============ 弹窗头部 ============
.privacy-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing-lg $spacing-xl;
  background: linear-gradient(135deg, $primary-fixed 0%, rgba($primary-fixed, 0.4) 100%);
  border-bottom: 1px solid $outline-variant;

  &-info {
    display: flex;
    align-items: center;
    gap: $spacing-md;
  }
}

.privacy-dialog__badge {
  width: 48px;
  height: 48px;
  border-radius: $border-radius-md;
  background-color: $primary-color;
  @include flex-center;
  box-shadow: 0 8px 16px rgba($primary-color, 0.3);

  i {
    font-size: 26px;
    color: $on-primary;
  }
}

.privacy-dialog__title {
  font-size: $font-size-xxl;
  font-weight: $font-weight-bold;
  color: $text-primary;
  margin: 0;
  line-height: 1.2;
}

.privacy-dialog__subtitle {
  font-size: $font-size-xs;
  color: $text-secondary;
  margin: 4px 0 0;
  letter-spacing: 0.02em;
}

.privacy-dialog__close {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background-color: rgba($bg-white, 0.8);
  color: $text-primary;
  cursor: pointer;
  @include flex-center;
  transition: all $transition-normal;

  i {
    font-size: 20px;
  }

  &:hover {
    background-color: $bg-white;
    transform: rotate(90deg);
    color: $primary-color;
  }
}

// ============ 弹窗正文 ============
.privacy-dialog__body {
  max-height: 68vh;
  overflow-y: auto;
  padding: $spacing-xl $spacing-xl $spacing-md;
  scroll-behavior: smooth;

  @include custom-scrollbar(6px);

  @include mobile {
    padding: $spacing-md;
  }
}

// 引言
.privacy-dialog__intro {
  margin-bottom: $spacing-xl;

  p {
    color: $text-on-surface-variant;
    font-size: $font-size-sm;
    line-height: $line-height-relaxed;
    margin: 0 0 $spacing-sm;

    a {
      color: $primary-color;
      text-decoration: underline;

      &:hover {
        color: $primary-active;
      }
    }
  }
}

.privacy-dialog__alert {
  display: flex;
  gap: $spacing-sm;
  align-items: flex-start;
  margin-top: $spacing-md;
  padding: $spacing-md;
  background-color: rgba($primary-fixed, 0.5);
  border-left: 3px solid $primary-color;
  border-radius: $border-radius-md;
  font-size: $font-size-sm;
  color: $on-primary-fixed-variant;
  line-height: $line-height-relaxed;

  i {
    color: $primary-color;
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 1px;
  }
}

// 目录
.privacy-dialog__toc {
  margin-bottom: $spacing-xl;
  padding: $spacing-lg;
  background-color: $bg-surface-low;
  border-radius: $border-radius-lg;
  border: 1px solid $border-color;

  &-title {
    font-size: $font-size-base;
    font-weight: $font-weight-semibold;
    color: $text-primary;
    margin: 0 0 $spacing-md;
    display: flex;
    align-items: center;
    gap: $spacing-xs;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 16px;
      background-color: $primary-color;
      border-radius: 2px;
    }
  }

  &-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $spacing-sm $spacing-lg;

    @include mobile {
      grid-template-columns: 1fr;
    }

    li {
      font-size: $font-size-sm;
    }

    a {
      color: $text-secondary;
      transition: all $transition-normal;
      cursor: pointer;
      display: block;
      padding: 4px 0;

      &:hover {
        color: $primary-color;
        transform: translateX(2px);
      }
    }
  }
}

// 章节
.privacy-dialog__section {
  margin-bottom: $spacing-xl;
  scroll-margin-top: $spacing-md;

  &-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-xl;
    font-weight: $font-weight-semibold;
    color: $text-primary;
    margin: 0 0 $spacing-md;
    padding-bottom: $spacing-sm;
    border-bottom: 1px solid $border-color;
  }

  &-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: $border-radius-sm;
    background-color: $primary-color;
    color: $on-primary;
    font-size: $font-size-sm;
    font-weight: $font-weight-bold;
    flex-shrink: 0;
  }

  &-content {
    color: $text-on-surface-variant;
    font-size: $font-size-sm;
    line-height: $line-height-relaxed;

    p {
      margin: 0 0 $spacing-sm;
    }

    h4 {
      font-size: $font-size-base;
      font-weight: $font-weight-semibold;
      color: $text-primary;
      margin: $spacing-md 0 $spacing-sm;
    }

    ul {
      padding-left: $spacing-lg;
      margin: 0 0 $spacing-sm;

      li {
        margin-bottom: 6px;
        line-height: $line-height-relaxed;
      }
    }

    strong {
      color: $text-primary;
      font-weight: $font-weight-semibold;
    }
  }
}

// 联系卡片
.privacy-dialog__contact-card {
  margin-top: $spacing-xl;
  padding: $spacing-xl;
  background: linear-gradient(135deg, $bg-surface-low 0%, $bg-white 100%);
  border-radius: $border-radius-lg;
  border: 1px solid $outline-variant;
}

.privacy-dialog__contact-title {
  display: flex;
  align-items: center;
  gap: $spacing-sm;
  font-size: $font-size-lg;
  font-weight: $font-weight-semibold;
  color: $text-primary;
  margin: 0 0 $spacing-md;

  i {
    color: $primary-color;
    font-size: 22px;
  }
}

.privacy-dialog__contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: $spacing-md;
  margin-bottom: $spacing-md;

  @include mobile {
    grid-template-columns: 1fr;
  }
}

.privacy-dialog__contact-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.privacy-dialog__contact-label {
  font-size: $font-size-xs;
  color: $text-tertiary;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.privacy-dialog__contact-value {
  font-size: $font-size-sm;
  color: $text-primary;
  font-weight: $font-weight-medium;

  &--link {
    color: $primary-color;

    &:hover {
      color: $primary-active;
      text-decoration: underline;
    }
  }
}

.privacy-dialog__contact-note {
  margin: 0;
  padding: $spacing-sm $spacing-md;
  background-color: $bg-white;
  border-radius: $border-radius-sm;
  font-size: $font-size-xs;
  color: $text-secondary;
  line-height: $line-height-relaxed;

  strong {
    color: $primary-color;
  }
}

// ============ 弹窗底部 ============
.privacy-dialog__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: $spacing-md $spacing-xl;
  background-color: $bg-surface-low;
  gap: $spacing-md;

  @include mobile {
    flex-direction: column;
    align-items: stretch;
    padding: $spacing-md;
  }

  &-hint {
    display: flex;
    align-items: center;
    gap: $spacing-xs;
    font-size: $font-size-xs;
    color: $text-secondary;

    i {
      font-size: 16px;
      color: $success-color;
    }

    @include mobile {
      font-size: 11px;
      order: 2;
      text-align: center;
      justify-content: center;
    }
  }

  &-actions {
    display: flex;
    gap: $spacing-sm;
    flex-shrink: 0;

    @include mobile {
      order: 1;
      justify-content: flex-end;
    }
  }
}

.privacy-dialog__btn {
  @include button-base;
  padding: 10px $spacing-lg;
  font-size: $font-size-sm;

  &--primary {
    background-color: $primary-color;
    color: $on-primary;

    &:hover {
      background-color: $primary-hover;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba($primary-color, 0.3);
    }

    i {
      font-size: 18px;
    }
  }

  &--ghost {
    background-color: transparent;
    color: $text-secondary;
    border: 1px solid $border-color;

    &:hover {
      background-color: $bg-white;
      color: $text-primary;
      border-color: $text-secondary;
    }
  }
}
</style>
